import { Popover, ArrowContainer } from 'react-tiny-popover';
import { AccountButton } from '../../../atomic/buttons/accountButton/AccountButton';
import { colors } from '../../../../colorVars';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { AccountBalancesTable } from './AccountBalancesTable';

export const AccountBalances = observer(() => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);


  return (
    <Popover
      isOpen={isPopoverOpen}
      positions={['bottom', 'left', 'right', 'top']}
      padding={10}
      onClickOutside={() => {}}
      content={({ position, childRect, popoverRect }) => (
        <ArrowContainer // if you'd like an arrow, you can import the ArrowContainer!
          position={position}
          childRect={childRect}
          popoverRect={popoverRect}
          arrowColor={colors.lightGrey}
          arrowSize={10}
          arrowStyle={{ opacity: 0.7 }}
          className="popover-arrow-container"
          arrowClassName="popover-arrow"
        >
          <AccountBalancesTable />
        </ArrowContainer>
      )}
    >
      <AccountButton
        clickHandler={() => setIsPopoverOpen((prev) => !prev)}
        color={colors.lightGrey}
        size={30}
      />
    </Popover>
  );
});
